import { createEntityAdapter } from '@reduxjs/toolkit'

import { PlanningUnassignedTable } from '../model/planning/PlanningUnassignedTable'

export const planningUnassignedTablesAdapter = createEntityAdapter({
  selectId: (table: PlanningUnassignedTable) => table.scenarioId,
})
